import styled from 'styled-components'
import { Col } from 'reactstrap'
import { Theme, Button } from '@pga/pga-component-library'

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;

  > :before {
    content: '';
    opacity: 0.3;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 99%;
    z-index: 5;
    @media (min-width: 992px) {
      background-image: ${`linear-gradient(0deg, ${Theme.primaryShadow}, ${Theme.colors.secondary})`};
    }
  }
`

export const Hero = styled.div`
  position: relative;
  background-color: ${Theme.colors.secondary};
  margin: 0;
  height: 320px;
  background-image: url(${props => props.backgroundImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left bottom;
  background-position-y: 80%;

  @media (min-width: 992px) {
    margin: -78px 0 0;
  }
`

export const HeroBody = styled.div`
  z-index: 2;
  @media screen and (min-width: 992px) {
    margin-top: 90px;
  }
  @media screen and (max-width: 991.98px) {
    margin-top: 20px;
  }
`

export const Content = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const Title = styled.h1`
  font-family: ${Theme.fonts.PlayfairDisplay};
  font-size: 38px;
  font-weight: 500;
  line-height: 0.95;
  letter-spacing: -0.3px;
  color: ${Theme.colors.primary};
  margin-bottom: 25px;

  @media (max-width: 767.99px) {
    font-size: 40px;
  }

  @media (max-width: 576.99px) {
    font-size: 28px;
    line-height: 0.95;
  }

  @media (max-width: 359.99px) {
    font-size: 28px;
    line-height: 0.95;
  }
`
export const ButtonLink = styled(Button)`
  background-color: ${Theme.colors.primary};
  color: white;
  margin-top: 16px;
  padding: 12px 15px;
  font-weight: 600;
`
